import { render, staticRenderFns } from "./PlateTextItem.vue?vue&type=template&id=2bc41108&scoped=true"
import script from "./PlateTextItem.vue?vue&type=script&lang=js"
export * from "./PlateTextItem.vue?vue&type=script&lang=js"
import style0 from "./PlateTextItem.vue?vue&type=style&index=0&id=2bc41108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc41108",
  null
  
)

export default component.exports